import { useEffect, useState } from 'react'
import { cn } from '../../lib/cn'

const CONSENT_KEY = 'ipt_consent_v0'

export default function ConsentBanner() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    try {
      const value = localStorage.getItem(CONSENT_KEY)
      setVisible(!value)
    } catch {
      setVisible(true)
    }
  }, [])

  if (!visible) return null

  return (
    <div className="fixed inset-x-0 bottom-0 z-50">
      <div className="mx-auto flex max-w-6xl flex-col gap-3 border-t border-white/10 bg-slate-950/95 px-4 py-4 backdrop-blur sm:flex-row sm:items-center sm:justify-between sm:px-6 lg:px-8">
        <div className="text-sm text-slate-200">
          Cookie/consent banner placeholder. Enable later when ads/analytics are added.
        </div>
        <div className="flex gap-2">
          <button
            className={cn(
              'rounded-lg border border-white/10 bg-white/5 px-3 py-2 text-sm text-slate-100',
              'transition hover:bg-white/10',
            )}
            onClick={() => {
              try {
                localStorage.setItem(CONSENT_KEY, 'dismissed')
              } catch {
                // ignore
              }
              setVisible(false)
            }}
          >
            Dismiss
          </button>
        </div>
      </div>
    </div>
  )
}

